const LAZY_LOAD_MENU_SIZE = 50;

export default LAZY_LOAD_MENU_SIZE;
